var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer footer-black footer-white"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-end"},[_c('div',{staticClass:"copyright pull-right text-white"},[_vm._v(" © GetInSync ")])])])])])
}]

export { render, staticRenderFns }